export default __webpack_public_path__ + "static/media/Gallery11.899d1e39.jpg";